import moment from 'moment';
import { useEffect } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { Flex } from 'reflexbox';

import { Spinner } from '@treams/treams-ui';
import { useCreateNoteMutation, useShareNoteMutation } from 'generated/graphql';
import { useHistory } from '@treams/treams-routes';

const NewNote = () => {
	const [create] = useCreateNoteMutation();
	const [share] = useShareNoteMutation();
	const history = useHistory();
	const { params } = useRouteMatch<{ collaboratorID?: string }>();

	useEffect(() => {
		(async () => {
			const response = await create({
				variables: { input: { date: moment().format('YYYY-MM-DD') } },
			});
			if (params.collaboratorID) {
				await share({
					variables: {
						input: { noteID: response.data!.createNote.note.id, userID: params.collaboratorID },
					},
				});
			}
			history.push(`/notes/${response.data!.createNote.note.id}`);
		})();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Flex my={4} justifyContent="center">
			<Spinner />
		</Flex>
	);
};

export default NewNote;
